module.exports = __webpack_public_path__ + "img/teeth-gutter.33684f77.png";